import { IncomeTileContent, IncomeTileContentProps } from "../IncomeTileContent";

export interface SubIncomeTileProps {
  subTiles: IncomeTileContentProps[];
}

export const SubIncomeTile = ({ subTiles }: SubIncomeTileProps) => {
  return (
    <div className="income-breakdown__tile">
      <div className="income-breakdown__sub-tiles">
        {subTiles.map((sub, i) => (
          <IncomeTileContent key={i} {...sub} />
        ))}
      </div>
    </div>
  );
};
